export default "__VITE_ASSET__ta0$sNFG__"